import "./ModalConfirm.css";
import { ReactComponent as Alert } from "./img/Icon awesome-exclamation-circle.svg";

function ModalSuccessFail(props) {
  return (
    <section className="modal-confirm">
      <div className="modal_content-confirm">
        <Alert />
        <p className="modal_p-confirm">{props.content}</p>
        <button className="modal_button-confirm-no" onClick={props.no}>NOT</button>
        <button className="modal_button-confirm" onClick={props.yes}>YES</button>
      </div>
    </section>
  )
}

export default ModalSuccessFail;
